import { Box } from "@mui/material";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Navbar from "./components/navbar";
import { useUserStore } from "./store/user-store";
import { hasAccessToPage } from "./utils/access-control";

function App() {
  document.title = "Aprende+";
  const { isAuthenticated, user } = useUserStore();
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to={"/login"} />;
  }

  // Verificar se o usuário tem acesso à página atual
  if (!hasAccessToPage(user, location.pathname)) {
    // Redirecionar USER para a home se tentar acessar página não autorizada
    return <Navigate to="/painel" />;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />
      <Box component="main" className="page-enter" key={location.pathname} sx={{ width: "100%", flex: 1, pb: 6 }}>
        <Outlet />
      </Box>
    </Box>
  );
}

export default App;
